<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.polls_index,
                    },
                    {
                        name: smileyPollQuestion.question,
                        href: meta.links.polls_show,
                    },
                    {
                        name: $t('messages.without_group'),
                        href: meta.links.index,
                    },
                    {
                        name: smileyPollResult.created_at,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <SmileyPoll :input-question="smileyPollQuestion.question" :input-results="smileyPollResult" />
        </div>

        <div class="md:grid md:grid-cols-6 md:gap-6">
            <div class="md:col-span-1">
                <QrImage :text="meta.links.edit" />
            </div>
            <div class="md:col-span-5">
                <FormInput :model-value="meta.links.edit" class="w-full" readonly />
                <div>
                    <AlertMessage class="mt-5">
                        <template v-slot:title>
                            {{ $t('messages.warning') }}
                        </template>
                        <template v-slot:body>
                            {{ $t('messages.visiting_the_page_logs_out_current_user') }}
                        </template>
                    </AlertMessage>
                </div>
                <div>
                    <AlertMessage class="mt-5" type="info">
                        <template v-slot:title>
                            {{ $t('messages.information') }}
                        </template>
                        <template v-slot:body>
                            {{
                                $t('messages.page_allows_voting_until_date', { date: smileyPollResult.expiration_date })
                            }}
                        </template>
                    </AlertMessage>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmileyPoll from '@/components/pageSpecific/SmileyPoll.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import QrImage from '@/components/QrImage.vue';
import FormInput from '@/components/Forms/FormInput.vue';

export default {
    components: {
        PanelPage,
        SmileyPoll,
        AlertMessage,
        QrImage,
        FormInput,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'smileyPollResult', 'smileyPollQuestion', 'group'],
};
</script>
